import React from "react";
import { createSvgIcon } from "@mui/material/utils";
const ArrowRight = createSvgIcon(/*#__PURE__*/React.createElement("path", {
  d: "M21.92,12.38a1,1,0,0,0,0-.76,1,1,0,0,0-.21-.33l-7-7a1,1,0,0,0-1.42,1.42L18.59,11H3a1,1,0,0,0,0,2H18.59l-5.3,5.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l7-7A1,1,0,0,0,21.92,12.38Z",
  "data-name": "arrow right"
}), "ArrowRight");
export default ArrowRight;